import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-vehicletypes',
    templateUrl: './vehicletypes.component.html',
    styleUrls: ['./vehicletypes.component.scss'],
    standalone: false
})
export class VehicletypesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
